'use client'

import React from 'react'
import ProvideConsentManagement from './ProvideConsentManagement'
import {internalLinks} from '~/routing/internal-links'
import {HgButton, HgTextLink} from '~/design-system/hg/components'
import {Analytics} from '~/utils/Analytics'
import isInEU from '@segment/in-eu'

type Props = Record<string, unknown>
type State = {
  eu: boolean
}

export default class GDPRBanner extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    let eu: boolean = true
    // `isInEU` uses `Intl` which some older browsers don't have.
    // Also apparently it blows up sometimes because the underlying jstz library has a bug here:
    // https://github.com/iansinnott/jstz/blob/528b77e9f827ec359cd3f08abe05ff27b597c4d5/jstz.main.js#L107
    // where they call a class constructor without adding `new`. This results in:
    // https://app.bugsnag.com/mercury-technologies/mercury-web/errors/5f37efc207c4ec001832150b?event_id=60dc46be007f5d05f50f0000&i=sk&m=oc
    // Instead of trying to patch all this up, we're just going to wrap it in a try/catch block and just pretend
    // it's an EU country to be safe if/when things go south.
    try {
      eu = isInEU()
    } catch {}
    this.state = {eu}
  }

  render() {
    return (
      <ProvideConsentManagement
        // TODO(CP-218): figure out how we want to handle MockConfig stuff
        // shouldRequireConsent={MockConfig.inEU ?? this.state.eu}
        shouldRequireConsent={this.state.eu}
      >
        {({saveConsent}) => (
          <div className="sticky bottom-0 z-cookie-banner-z-index flex w-full flex-row items-center justify-center bg-[linear-gradient(180deg,rgba(255,255,255,0.96)_0%,rgba(249,249,251,0.96)_100%)] px-s5 py-s3 text-center text-text-default shadow-[0px_10px_40px_rgba(113,113,142,0.1)] arcadia-body-2">
            <span>
              <HgTextLink
                variant="underline"
                href={{pathname: internalLinks.legal.privacy}}
              >
                We use cookies
              </HgTextLink>{' '}
              to optimize your browsing experience. Click ‘OK’ to agree, or
              <HgButton
                variant="text"
                onClick={() => {
                  Analytics.trackClick('gdpr/optout')
                  saveConsent('optout')
                }}
                className="ml-s2 underline"
              >
                opt out
              </HgButton>
              <HgButton
                variant="tonal"
                onClick={() => {
                  Analytics.trackClick('gdpr/optin')
                  saveConsent('optin')
                }}
                className="ml-s2"
              >
                OK
              </HgButton>
            </span>
          </div>
        )}
      </ProvideConsentManagement>
    )
  }
}
